import BaseAtomView from 'views/atoms/base-atom-view';
import LinkTemplate from './templates/link-atom';
import Handlebars from 'handlebars/runtime';
import IconAtomView from 'views/atoms/icon-atom/icon-atom-view';
import TooltipAtomView from 'views/atoms/tooltip-atom/tooltip-atom-view';
import Chaplin from 'chaplin';

const LinkAtomView = BaseAtomView.extend({
  template: LinkTemplate,
  initialize: function () {
    BaseAtomView.prototype.initialize.apply(this, arguments);
  },
  render: function () {
    BaseAtomView.prototype.render.apply(this, arguments);
    this.loadDecorations();
    const SELECTOR = this.model.get('decorations')?.isButton ? 'button' : 'a';
    const link = this.el.querySelector(SELECTOR);
    this.setAttributes(link);
    this.delegate('click', SELECTOR, this.clickHandler);
  },
  loadDecorations() {
    const decorations = this.model.get('decorations');
    if (!decorations) {
      return;
    }
    if (decorations.beforeIcon) {
      this.loadIcon(decorations.beforeIcon['icon-fontawesome'], 'Before');
    }
    if (decorations.afterIcon) {
      this.loadIcon(decorations.afterIcon['icon-fontawesome'], 'After');
    }
    if (decorations.tooltip) {
      this.loadTooltip(decorations.tooltip);
    }
  },
  loadTooltip(modelref) {
    requestAnimationFrame(() => {
      const region = `atom-tooltip-${this.model.cid}`;
      this.registerRegion(region, `[data-region="${region}"]`);
      const tooltipmodel = new Chaplin.Model(modelref);
      tooltipmodel.set('parentView', this);
      this.subview(
        region,
        new TooltipAtomView({
          model: tooltipmodel,
          region,
        })
      );
    });
  },
  loadIcon(model, position) {
    this.registerRegion(`icon${position}-${this.model.cid}`, `.icon${position}-${this.model.cid}`);

    this.subview(
      `icon${position}-${this.model.cid}`,
      new IconAtomView({
        model: new Chaplin.Model(model),
        region: `icon${position}-${this.model.cid}`,
      })
    );
  },
  clickHandler(event) {
    const link = event.currentTarget;
    if (link.getAttribute('href') === '') {
      event.preventDefault();
    }
    this.publishEvent(
      'link:clicked',
      {
        id: this.model.get('action')?.['dom-identifier']?.['dom-id'] || `link-atom-${this.model.cid}`,
        data: link.dataset,
      },
      this.model.get('parentBlockView') ? this.model.get('parentBlockView') : this
    );
  },
  // Similar to the setAttributes in the link-view, but uses schema from JAML modules
  setAttributes(link) {
    const action = this.model.get('action');
    let dataset = {};
    link.dataset['actiontype'] = action.actiontype;
    if (!action.actiontype) {
      console.warn('No actiontype provided for the link atom');
      return;
    }
    switch (action.actiontype) {
      case 'navigate':
        if (action?.destination?.path?.[0] === '#') {
          dataset.navigate = Handlebars.Utils.escapeExpression(action.destination.path.substring(1));
          break;
        }
        dataset.navigate = Handlebars.Utils.escapeExpression(action.destination?.path);
        break;
      case 'open_modal':
        dataset.actiontype = 'open_modal';
        dataset.target = action.target;
        break;
      case 'twine':
        dataset = this.getActionAttrs(action, dataset);
        break;
      case 'close_content':
        if (action['safe-exit']) {
          dataset.safeExit = true;
          dataset.redirect = action.path;
        }
        break;
      case 'complete':
        dataset.actiontype = 'navigate';
        dataset.navigate = 'complete';
        break;
      case 'completeme':
        dataset.actiontype = 'navigate';
        dataset.navigate = 'completeme';
        break;
      case 'scroll':
        dataset.navigate = 'scroll';
        dataset.scrollPane = action.scrollPane || 'html, body';
        dataset.offsetTop = action.offsetTop ? Handlebars.Utils.escapeExpression(action.offsetTop) : 0;
        dataset.target = action.target;
        break;
      case 'window':
        dataset.actiontype = 'navigate';
        dataset.navigate = 'window';
        dataset.windowNavigate = action.destination.path;
        break;
      case 'new_window':
        link.setAttribute('target', '_blank');
        dataset.actiontype = 'navigate';
        dataset.navigate = 'new_window';
        dataset.windowNavigate = action.url.path;
        break;
      case 'none':
        dataset.actiontype = 'action';
        if (action['dom-identifier']?.['dom-id']) {
          dataset.target = action['dom-identifier']['dom-id'];
        }
        break;
      case 'audio_playback':
        dataset.action = action.action;
        dataset.audio_id = action.audio_id;
        break;
      default:
        console.warn("The link atom couldn't generate your link.");
    }
    Object.entries(dataset).forEach(([key, val]) => {
      link.dataset[key] = val;
    });
  },
});

export default LinkAtomView;
